/* 3D4M site-footer interacties.
   Currency-switcher: open/dicht van het dropdown-menu. De opties zijn submit-knoppen
   binnen de Shopify localization-form, dus een klik submit de form en Shopify zet de
   currency (currency volgt het land/market) — geen client-side re-pricing.
   Bron: Creaties/Backend/shared/header-footer-inject.js (initFooter, open/dicht-deel). */
(function () {
  /* Elke .currency-switch op de pagina, niet alleen de eerste: sinds 2026-10-12 staat de
     kiezer ook onderaan het mobiele menu (snippet currency-switch, Vince). Elk exemplaar heeft
     zijn eigen menu en zoekdialoog. */
  function initFooter() {
    Array.prototype.forEach.call(document.querySelectorAll('.currency-switch'), initSwitch);
  }
  function initSwitch(sw) {
    var trigger = sw.querySelector('.currency-trigger');
    var menu = sw.querySelector('.currency-menu');
    if (!trigger || !menu) return;

    function openMenu() { menu.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true'); }
    function closeMenu() { menu.classList.remove('is-open'); trigger.setAttribute('aria-expanded', 'false'); }
    function isOpen() { return menu.classList.contains('is-open'); }

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      isOpen() ? closeMenu() : openMenu();
    });
    document.addEventListener('click', function (e) {
      if (isOpen() && !sw.contains(e.target)) closeMenu();
    });

    // Search dialog — opened from the "More" row. Rows are localization-form
    // submits (server sets the currency), so the JS only opens/closes the
    // dialog and filters the static rows by text (code + currency name).
    var searchBtn = sw.querySelector('[data-currency-search]');
    var dialog = sw.querySelector('.currency-dialog');
    var input = dialog && dialog.querySelector('.currency-dialog-input');
    var results = dialog && dialog.querySelector('.currency-results');
    var rows = results ? Array.prototype.slice.call(results.querySelectorAll('.currency-result')) : [];
    var emptyEl = null;

    function dialogOpen() { return dialog && dialog.classList.contains('is-open'); }
    function filterRows(q) {
      q = (q || '').trim().toLowerCase();
      var shown = 0;
      rows.forEach(function (r) {
        var match = !q || r.textContent.toLowerCase().indexOf(q) > -1;
        r.style.display = match ? '' : 'none';
        if (match) shown++;
      });
      if (shown === 0) {
        if (!emptyEl) {
          emptyEl = document.createElement('div');
          emptyEl.className = 'currency-results-empty';
          results.appendChild(emptyEl);
        }
        emptyEl.textContent = 'No currencies match “' + input.value.trim() + '”.';
        emptyEl.style.display = '';
      } else if (emptyEl) {
        emptyEl.style.display = 'none';
      }
    }
    function openDialog() {
      input.value = '';
      filterRows('');
      dialog.classList.add('is-open');
      /* Pagina vastzetten zolang de dialoog open staat, net als het mobiele menu doet.
         Zonder dit scrolt de pagina eronder weg zodra het wieltje net naast de lijst
         landt (op de kop, het zoekveld of de achtergrond), en dan lijkt het alsof de
         lijst zelf niet scrolt. Geconstateerd 2026-08-08. */
      document.body.style.overflow = 'hidden';
      setTimeout(function () { input.focus(); }, 0);
    }
    function closeDialog() {
      if (!dialog) return;
      dialog.classList.remove('is-open');
      /* Staat het mobiele menu nog open (kiezer onderaan het menu), dan blijft de pagina vast. */
      document.body.style.overflow = document.querySelector('.nav-mobile.is-open') ? 'hidden' : '';
    }

    if (searchBtn && dialog && input && results) {
      searchBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        closeMenu();
        openDialog();
      });
      input.addEventListener('input', function () { filterRows(input.value); });
      // Enter inside the search field would submit the localization form
      // (first submit button) — block it; selecting a row is the submit path.
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });
      dialog.querySelectorAll('[data-currency-close]').forEach(function (el) {
        el.addEventListener('click', closeDialog);
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (dialogOpen()) { closeDialog(); trigger.focus(); }
      else if (isOpen()) { closeMenu(); trigger.focus(); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooter);
  } else {
    initFooter();
  }
})();
